<template>
    <div class="product-index" :class="{
        'product-index-highlights': active === 'productHighlights'
    }">
        <img
            class="base-banner"
            v-src="'https://oss.cloud.custouch.com/res/11265/产品中心@3x.png'"
        />
        <van-tabs v-model="active" animated="animated" type="card" title-inactive-color="#666666">
            <van-tab
                :title="item.title"
                :name="item.name"
                v-for="item in list"
                :key="item.name"
            >
            </van-tab>
        </van-tabs>
        <router-view></router-view>
    </div>
</template>
<script>
export default{
    data(){
        return {
            list: [
                {
                    name: 'productCenter',
                    title: '产品中心'
                },
                {
                    name: 'productHighlights',
                    title: '重点推荐'
                },
            ]
        }
    },
    computed: {
        active: {
            set(name) {
                this.$router.replace({ name })
            },
            get() {
                return this.$route.name
            }
        }
    },
}
</script>
<style lang="less">
.product-index{
    &.product-index-highlights{
        background: #F9F9F9;
    }
    .base-banner{
        margin-bottom: @padding-lg;
        vertical-align: top;
    }
    .van-tabs--card{
        .van-tabs__wrap{
            height: 2.2rem;
            padding-bottom: @spacing;
            box-sizing: content-box;
            .van-tabs__nav--card{
                border-width: 0;
                height: 2.2rem;
                box-shadow: 0 0.1rem 0.2rem 0 #004da029;
                border-radius: 1.1rem 0.3rem 1.1rem 0.3rem;
                .van-tab{
                    border-right-width: 0;
                    font-size: @font-size-lg;
                }
                .van-tab--active{
                    border-radius: 1.1rem 0.3rem 1.1rem 0.3rem;
                }
            }
        }
    }
}
</style>